import {endpoint} from "@/utils/api/Conf";
import {Segments} from "@/types/Segments";

export const pathSegmentsRequest = async (pathId: string): Promise<Segments | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
    }
    return await fetch(endpoint + `paths/${pathId}/segments?order_by=seg_num&page_size=70`, init)
      .then((response) => response.json())
      .then((data: Segments) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};

export const segmentsRequest = async (search: string, locale: string): Promise<Segments | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
      headers: {
        "X-Language": locale || "it"
      }
    }
    return await fetch(endpoint + `segments?order_by=seg_num&search=${search}`, init)
      .then((response) => response.json())
      .then((data: Segments) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};
